export const METHODOLOGY = {
  name: "The Silvertree Consulting Methodology™",
  intro:
    "Every engagement follows a structured, disciplined, business-first approach. The methodology keeps us focused on outcomes — not activity — and gives you visibility and confidence at every step.",
  phases: [
    {
      key: "Discover",
      icon: "Telescope",
      tagline: "Understand the business before the technology.",
      description:
        "We begin by listening. Through structured conversations with leadership and the people who do the work, we build a clear picture of your goals, operations, constraints, and the outcomes that matter most.",
      outcomes: ["Stakeholder alignment", "Current-state understanding", "Defined objectives"],
    },
    {
      key: "Analyze",
      icon: "ScanSearch",
      tagline: "Surface what's really happening.",
      description:
        "We examine processes, systems, data, and spend to identify gaps, risks, and opportunities. Findings are grounded in evidence — not assumptions — so decisions rest on a solid foundation.",
      outcomes: ["Gap and risk analysis", "Opportunity identification", "Evidence-based findings"],
    },
    {
      key: "Align",
      icon: "Target",
      tagline: "Connect technology to strategy.",
      description:
        "We translate findings into prioritized recommendations tied directly to business objectives. Leadership gains a clear, agreed-upon plan that reflects real priorities and budget.",
      outcomes: ["Prioritized recommendations", "Strategic alignment", "Agreed-upon plan"],
    },
    {
      key: "Transform",
      icon: "Workflow",
      tagline: "Execute with structure and accountability.",
      description:
        "We guide execution in deliberate, value-led phases — coordinating teams and vendors, managing risk, and maintaining visibility so initiatives actually finish and deliver value.",
      outcomes: ["Disciplined execution", "Coordinated delivery", "Realized value"],
    },
    {
      key: "Optimize",
      icon: "TrendingUp",
      tagline: "Measure, refine, improve.",
      description:
        "Once solutions are in place, we measure results against the outcomes we defined, refine what isn't working, and capture the data that informs the next set of decisions.",
      outcomes: ["Performance measurement", "Continuous refinement", "Better decisions"],
    },
    {
      key: "Sustain",
      icon: "ShieldCheck",
      tagline: "Protect and extend the gains.",
      description:
        "We help you sustain progress over time — maintaining governance, managing risk, and serving as an ongoing advisor so improvements hold and the business keeps moving forward.",
      outcomes: ["Ongoing governance", "Risk management", "Long-term advisory"],
    },
  ],
};

// ---------- Industries ----------
